import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import axios from "axios";
import { KATALOG_API } from "../../consts/Endpoints";

const SITE_KODU = { trendyol: "TRENDYOL", hepsiburada: "HEPSIBURADA", amazon: "AMAZON", n11: "N11", pazarama: "PAZARAMA", idefix: "IDEFIX" };

/**
 * İndirim detayından ürünün kalıcı sayfasına (`/urun/...`, 2026-11-05) bağlantı: katalog `api/urun-yolu`. Ürün son 30 günde
 * indirim yakalanmış olduğu için çoğunlukla vardır; yoksa hiçbir şey çizilmez. Google ürün sayfalarını bu linklerden de bulur.
 */
export default function UrunSayfasiLinki({ site, u, ad }) {
  const [yol, setYol] = useState(null);
  const magaza = site === "elektronik" ? u && u.magaza : SITE_KODU[site];
  const urunId = u && u.id != null ? String(u.id) : null;

  useEffect(() => {
    if (!KATALOG_API || !magaza || !urunId) return undefined;
    let iptal = false;
    axios.get(KATALOG_API + "api/urun-yolu", { params: { magaza, urunId } })
      .then((r) => { if (!iptal && r.data && r.data.yol) setYol(r.data.yol); })
      .catch(() => { });
    return () => { iptal = true; };
  }, [magaza, urunId]);

  if (!yol) return null;
  return (
    <Link className="ud-urun-linki" to={yol}>
      📈 {ad ? ad + " ürün sayfası" : "Ürün sayfası"}: tüm fiyat geçmişi, diğer mağazalar ve fiyat alarmı →
    </Link>
  );
}
